<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="750px"
    title="修改楼盘图片"
    :visible.sync="dialogFormVisible"
    @opened="getLoad"
    @close="resetFrom()"
  >
    <el-form :model="editForm" :ref="editForm">
      <div
        v-for="(item, index) in editForm.data"
        :key="index"
        style="border: 2px #ddd dotted; padding: 10px; margin-bottom: 10px"
      >
        <el-form-item
          label="图片分组"
          :label-width="formLabelWidth"
          prop="groupName"
        >
          <el-input v-model="item.groupName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="是否显示"
          :label-width="formLabelWidth"
          prop="isPlan"
        >
          <el-switch
            v-model="item.isPlan"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        <el-form-item label="楼盘图片" :label-width="formLabelWidth">
          <div
            v-for="(list, indez) in item.housePictures"
            :key="indez"
            style="
              display: block;
              height: 140px;
              position: relative;
              margin: 0 0 10px;
            "
          >
            <el-col :span="8">
              <!-- 图片上传 -->
              <!-- <el-upload class="avatar-uploader"
                :show-file-list="false">
                <img v-if="list.imgUrl" :src="list.imgUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>-->
              <el-upload
                class="avatar-uploader"
                :action="actionUrl"
                :data="{ index, indez }"
                :show-file-list="false"
                :http-request="httpRequest"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="list.imgUrl" :src="list.imgUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <el-button
                  v-if="list.imgUrl"
                  type="primary"
                  class="deleteBtn"
                  plain
                  @click.stop="deleteP(index, indez)"
                  >删除</el-button
                >
                <!-- <a
                  v-if="list.imgUrl"
                  href="javascript:void(0)"
                  class="deleteBtn"
                  @click.stop="deleteP(index, indez)"
                  >删除</a
                > -->
              </el-upload>
            </el-col>
            <el-col :span="16">
              <el-form-item label="图片标题" :label-width="formLabelWidth">
                <el-input v-model="list.title" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item
                label="备注/户型"
                style="margin: 10px 0"
                :label-width="formLabelWidth"
              >
                <el-input v-model="list.info" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="描述/面积" :label-width="formLabelWidth">
                <el-input v-model="list.area" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </div>
          <el-button
            type="button"
            plain
            @click="addP(index)"
            style="margin-right: 10px"
            >添加图片</el-button
          >
          <el-button type="button" plain @click="deleteT(index)"
            >删除分组</el-button
          >
        </el-form-item>
      </div>
      <el-button type="button" plain @click="addE">添加分组</el-button>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom();
          dialogFormVisible = false;
        "
        style="margin-right: 10px"
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formGroupData } from '../form.js';
import { houseGetGroups, houseGroupEdit, houseUpload } from '@/api/houseApi.js'; // 、、houseGetGroups
//
export default {
  name: 'editHousesGroup',
  data() {
    return {
      houseId: '',
      dialogTitle: '',
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      editForm: { ...formGroupData }, // 编辑表单
      imageUrl: '',
      actionUrl: '',
    };
  },
  inject: ['reload'],
  computed: {},
  mounted() {},
  methods: {
    addE: function () {
      let cope = {
        groupName: '',
        remark: '',
        info: '',
        isPlan: false,
        housePictures: [
          {
            title: '',
            info: '',
            area: '',
            imgUrl: '',
          },
        ],
      };
      this.editForm.data.push(cope);
    },
    addP: function (index) {
      let copex = {
        title: '',
        info: '',
        area: '',
        imgUrl: '',
      };
      this.editForm.data[index].housePictures.push(copex);
    },
    deleteT: function (index) {
      this.editForm.data.splice(index, 1);
    },
    deleteP: function (index, indexz) {
      // console.log('index', index, 'indexz', indexz);
      // console.log('this.editForm', this.editForm);
      // this.editForm.data[index].housePictures.splice(indexz, 1);
      this.editForm.data[index].housePictures[indexz].imgUrl = '';
    },
    // 上传图片前验证规则
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      //const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      /*  if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M */
      return isJPG;
    },

    httpRequest(options) {
      let file = options.file;
      let reader = new FileReader();

      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file);
      };
    },
    dealImg(options, base64Str, file) {
      let _this = this;
      var image = new Image();
      image.src = base64Str;
      image.setAttribute('crossOrigin', 'Anonymous');

      image.onload = function () {
        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // 图片原始尺寸
        var originWidth = this.width;
        var originHeight = this.height;

        // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        var maxWidth = 4200,
          maxHeight = 4200;
        // 目标尺寸
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // 图片尺寸超过300x300的限制
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片压缩
        context.drawImage(image, 0, 0, targetWidth, targetHeight);
        /*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/

        //压缩后的图片转base64 url
        /*canvas.toDataURL(mimeType, qualityArgument),mimeType 默认值是'image/png';
         * qualityArgument表示导出的图片质量，只有导出为jpeg和webp格式的时候此参数才有效，默认值是0.92*/
        var base64 = canvas.toDataURL('image/jpeg', 0.92); //base64 格式
        houseUpload({
          base64String: base64,
          fileName: file.name,
        })
          .then((res) => {
            _this.editForm.data[options.data.index].housePictures[
              options.data.indez
            ].imgUrl = res.data.absoluteFileUrl;
          })
          .catch((err) => {
            window.console.log(err);
          });
      };
    },

    del: function (index) {
      this.editForm.splice(index, 1);
    },
    resetFrom() {
      this.editForm = formGroupData;
    },
    // 删除图片
    handleRemove(file, fileList) {
      window.console.log(file, fileList);
    },

    // 上传图片
    handlePreview(file) {
      window.console.log(file);
    },
    getLoad() {
      houseGetGroups(this.houseId).then((res) => {
        if (res.data != null) this.editForm.data = res.data;
      });
    },
    submitEdit() {
      try {
        if (this.houseId != '') {
          console.log('编辑参数：', this.editForm);
          houseGroupEdit(this.houseId, [...this.editForm.data]).then((res) => {
            if (res.code === 200) {
              this.$message.success('编辑成功!');
            } else {
              this.$message.error('编辑失败!');
              return;
            }
          });
        }
        this.dialogFormVisible = false;
        this.editForm = {};
        // 重新获取数据
        this.reload();
      } catch (e) {
        window.console.log(e);
      }
    },
  },
  created() {},
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 200px;
  height: 120px;
}
.deleteBtn {
  position: absolute;
  right: 6px;
  bottom: 0px;
  color: #d9d9d9;
}
</style>
